import { getScheduledTransfers } from "../../graph/scheduledTransfer";
export var LIST_SCHEDULED_TRANSFERS = "LIST_SCHEDULED_TRANSFERS";
export var CLEAR_SCHEDULED_TRANSFERS = "CLEAR_SCHEDULED_TRANSFERS";
var list = function (existingScheduledTransfers, newScheduledTransfers, newCursor) {
    return {
        type: LIST_SCHEDULED_TRANSFERS,
        existingScheduledTransfers: existingScheduledTransfers,
        newScheduledTransfers: newScheduledTransfers,
        newCursor: newCursor
    };
};
var clear = function () {
    return {
        type: CLEAR_SCHEDULED_TRANSFERS
    };
};
export var listScheduledTransfers = function (existingScheduledTransfers, walletOwnerId, walletId, scheduledTransferStatusParam, cursor, limit) {
    return function (dispatch) {
        return getScheduledTransfers(walletOwnerId, walletId, scheduledTransferStatusParam, cursor, limit).then(function (_a) {
            var results = _a.results, newCursor = _a.cursor;
            return dispatch(list(existingScheduledTransfers, results, newCursor));
        });
    };
};
export var clearScheduledTransfers = function () {
    return function (dispatch) { return dispatch(clear()); };
};
export default {
    list: listScheduledTransfers,
    clear: clearScheduledTransfers
};
